import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["userId", "weekCommencingDate", "enabled"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from 'utils/api';
import usersKeys from './queryKeys';
import useFetchUserHelixAccess from './useFetchUserHelixAccess';
export function fetchUserAnalysis(_x) {
  return _fetchUserAnalysis.apply(this, arguments);
}
function _fetchUserAnalysis() {
  _fetchUserAnalysis = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var userId, weekCommencingDate;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          userId = _ref.userId, weekCommencingDate = _ref.weekCommencingDate;
          return _context.abrupt("return", api('get', '/api/userAnalysis', {
            userId: userId,
            weekCommencingDate: weekCommencingDate
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchUserAnalysis.apply(this, arguments);
}
function useFetchUserAnalysis(_ref2) {
  var userId = _ref2.userId,
    weekCommencingDate = _ref2.weekCommencingDate,
    enabled = _ref2.enabled,
    queryOptions = _objectWithoutProperties(_ref2, _excluded);
  var queryClient = useQueryClient();
  var currentKey = usersKeys.singleUserAnalysis(userId, weekCommencingDate);

  // The user's analysis only exists on their designated Helix domain, so
  // only fetch it once we know this hub is that user's Helix hub
  var _useFetchUserHelixAcc = useFetchUserHelixAccess({
      userId: userId
    }),
    helixAccessData = _useFetchUserHelixAcc.data;
  var _ref3 = helixAccessData || {},
    isHelixHub = _ref3.isHelixHub;

  // if enabled is not explicitly set to false then only fetch once we know
  // this hub is the user's Helix hub
  if (enabled === true || enabled === undefined) {
    enabled = Boolean(isHelixHub);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({}, queryOptions), {}, {
      queryFn: function queryFn() {
        return fetchUserAnalysis({
          weekCommencingDate: weekCommencingDate,
          userId: userId
        });
      },
      initialData: function initialData() {
        // Try to pull from cache for instant render
        var cached = queryClient.getQueryData(currentKey);
        return cached;
      },
      queryKey: currentKey,
      staleTime: 5 * 60 * 1000,
      // 5 minutes
      enabled: enabled
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchUserAnalysis;